import { useState, useEffect } from 'react'
import useBlackoutMutations from 'Shared/CalendarBlock/hooks/useBlackoutMutations'
import { Alert, Button } from 'reactstrap'
import ViewModal from 'Shared/ViewModal/ViewModal'

const DeleteBlockedModal = ({ showModal, resData, onClose }) => {
  const [modalState, setModalState] = useState(false)
  const [success, setSuccess] = useState(false)
  const { fromEdit: from, toEdit: to } = resData || {}

  const { handleDeleteBlock } = useBlackoutMutations({
      blackoutId: resData?.blackoutId,
      deleteBlock: true,
      setSuccess,
  })

  useEffect(() => {
    setModalState(showModal)
  }, [showModal])

  const toggle = () => {
    setModalState(false)
    setSuccess(false)
    if (onClose) onClose()
  }

  return (
    <ViewModal classes={{ header: 'bg-salmon text-white ' }} size="lg"
                  showCloseIcon toggle={toggle} isOpen={modalState} showOkButton={false}
                  title="Confirm Block Removal">
      <div>
        Clicking OK will DELETE this blocked off section and will open
        up <span className="text-break">{resData?.siteEdit}</span> from {from}
        &nbsp;to {to}. Please click Cancel if you do not wish to remove this blocked off section.
      </div>

      {success && <Alert color="success">Date block removed</Alert>}

      <hr />

      <div className="d-flex justify-content-end">
        <Button color="secondary" className="mx-1" onClick={toggle}>Cancel</Button>
        <Button color="salmon" className="mx-1" disabled={success} onClick={handleDeleteBlock}>OK</Button>
      </div>
    </ViewModal>
  )
}

export default DeleteBlockedModal
